import { Fragment, jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { useCallback, useMemo } from "react";
import { getUpdatedSelection } from "./core/getUpdatedSelection.js";
const ItemWrapper = styled("div", {
  name: "ItemWrapper"
})`
  position: absolute;
  left: 0;
  width: 100%;
`;
function ItemsRenderer(props) {
  const { onSelect, RenderItem, renderedItems: visibleItems, selectedItemIds, itemsWithPosition } = props;
  const handleClick = useCallback(
    (params) => {
      const { item, event: modifiers } = params;
      onSelect({
        item,
        modifiers,
        newSelectedIds: getUpdatedSelection({
          items: itemsWithPosition,
          oldSelectedIds: selectedItemIds,
          clickedItemId: item.id,
          modifiers
        })
      });
    },
    [itemsWithPosition, onSelect, selectedItemIds]
  );
  const children = useMemo(
    () => visibleItems.map(({ item, y }) => /* @__PURE__ */ jsx(ItemWrapper, { style: { top: y }, children: /* @__PURE__ */ jsx(RenderItem, { item, selected: selectedItemIds.includes(item.id), onClick: handleClick }) }, item.id)),
    [visibleItems, RenderItem, selectedItemIds, handleClick]
  );
  return /* @__PURE__ */ jsx(Fragment, { children });
}
export {
  ItemsRenderer
};
//# sourceMappingURL=ItemsRenderer.js.map
